export type MaltaFullTimeFeeLineKey =
  | "tuitionFee"
  | "acommodation"
  | "medicalInsurance"
  | "residencePermit"
  | "admissionFee"
  | "otherExpenses"
  | "transfer"
  | "certificationEqualization"
  | "completeOneYear";

export type MaltaFullTimeFeeVisibility = Record<MaltaFullTimeFeeLineKey, boolean>;

export type MaltaFullTimeNoticeKey =
  | "transferFeeNotice"
  | "admissionLetterNotice"
  | "firstYearPaymentConfirmation";

export const MALTA_FULL_TIME_FEE_LINE_ORDER: MaltaFullTimeFeeLineKey[] = [
  "tuitionFee",
  "acommodation",
  "medicalInsurance",
  "residencePermit",
  "admissionFee",
  "otherExpenses",
  "transfer",
  "certificationEqualization",
  "completeOneYear",
];

export const MALTA_FULL_TIME_FEE_VISIBILITY_FIELD: Record<MaltaFullTimeFeeLineKey, keyof MaltaFullTimeFeeVisibilityFormKeys> = {
  tuitionFee: "tuitionFeeVisible",
  acommodation: "acommodationVisible",
  medicalInsurance: "medicalInsuranceVisible",
  residencePermit: "residencePermitVisible",
  admissionFee: "admissionFeeVisible",
  otherExpenses: "otherExpensesVisible",
  transfer: "transferVisible",
  certificationEqualization: "certificationEqualizationVisible",
  completeOneYear: "completeOneYearVisible",
};

export interface MaltaFullTimeFeeVisibilityFormKeys {
  tuitionFeeVisible: boolean;
  acommodationVisible: boolean;
  medicalInsuranceVisible: boolean;
  residencePermitVisible: boolean;
  admissionFeeVisible: boolean;
  otherExpensesVisible: boolean;
  transferVisible: boolean;
  certificationEqualizationVisible: boolean;
  completeOneYearVisible: boolean;
}

export const DEFAULT_MALTA_FULL_TIME_FEE_VISIBILITY: MaltaFullTimeFeeVisibility = {
  tuitionFee: true,
  acommodation: true,
  medicalInsurance: true,
  residencePermit: true,
  admissionFee: true,
  otherExpenses: true,
  transfer: true,
  certificationEqualization: true,
  completeOneYear: true,
};

export const DEFAULT_MALTA_FULL_TIME_FEE_VALUES: Record<MaltaFullTimeFeeLineKey, string> = {
  tuitionFee: "5 000",
  acommodation: "1 200",
  medicalInsurance: "600",
  residencePermit: "200",
  admissionFee: "1 000",
  otherExpenses: "800",
  transfer: "300",
  certificationEqualization: "1 000",
  completeOneYear: "8 800",
};

export const MALTA_FULL_TIME_FEE_LINE_SUFFIXES: Record<MaltaFullTimeFeeLineKey, string> = {
  tuitionFee: " EUR every year",
  acommodation: " EUR every year",
  medicalInsurance: " EUR (100 EUR per a year) one-time payment",
  residencePermit: " EUR one-time payment",
  admissionFee: " EUR one-time payment",
  otherExpenses: " EUR first year only",
  transfer: " EUR one-time payment",
  certificationEqualization: " EUR (first year only)",
  completeOneYear: " EUR per year",
};

export const formatMaltaFullTimeFeeLineDisplay = (key: MaltaFullTimeFeeLineKey, numericValue?: string) => {
  const trimmed = numericValue?.trim();
  if (!trimmed) return "";
  return `${trimmed}${MALTA_FULL_TIME_FEE_LINE_SUFFIXES[key]}`;
};

export const MALTA_FULL_TIME_FEE_LINE_LABELS: Record<MaltaFullTimeFeeLineKey, string> = {
  tuitionFee: "Tuition Fee",
  acommodation: "Accommodation",
  medicalInsurance: "Medical Insurance",
  residencePermit: "Temporary Residence Permission and Medical Check-Up",
  admissionFee: "Admission Fee",
  otherExpenses: "Other Expenses (Administrative Fee, Registration Fee, Application Fee, etc.)",
  transfer: "Transfer Charges",
  certificationEqualization: "Certification and Equalization of all documents",
  completeOneYear: "Complete first year expenses",
};

export const MALTA_FULL_TIME_NOTICE_ORDER: MaltaFullTimeNoticeKey[] = [
  "transferFeeNotice",
  "admissionLetterNotice",
  "firstYearPaymentConfirmation",
];

export const MALTA_FULL_TIME_NOTICE_LABELS: Record<MaltaFullTimeNoticeKey, string> = {
  transferFeeNotice: "Transfer Fee Notice",
  admissionLetterNotice: "Admission Letter Notice",
  firstYearPaymentConfirmation: "First-Year Payment Confirmation",
};

export const MALTA_FULL_TIME_NOTICE_TEXT: Record<MaltaFullTimeNoticeKey, string> = {
  transferFeeNotice:
    "Kindly note that since you are starting from the upper year the transfer fee which is based on your academic difference will be calculated on your arrival and might be requested additionally from your side.",
  admissionLetterNotice:
    "This Admission Letter confirms your eligibility to study in International European University. Please note that additional expenses are possible on arrival.",
  firstYearPaymentConfirmation:
    "To continue the admission process and to enroll to the university, you need to cover the complete first year fee. After the payment is received you will be officially accepted to the university and provided with your personal Student\u2019s Office. There you will have an access to your personalized curriculum, all the educational materials, lectures, textbooks, etc. The classes will be provided according to your schedule and curriculum.",
};
